import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './EmployerPortalCandidates.module.css';
import employersJobStyles from '../EmployerPortalJobs/EmployerPortalJobs.module.css';
import Yup from '../../../../utils/yupExtensions';
import { City } from 'country-state-city';
import { filterUI } from './FilterUI';
import { useFormik } from 'formik';
import { deleteApplication, deleteCandidates, getEmployerApplicationsList, getJobsList } from '../../../../services/jobService';
import { TableHeaderUI } from './TableHeader';
import { t } from 'i18next';
import { getFavoriteTalents, getJobSeekerList, getTalentsList } from '../../../../services/TalentsService';
import { useGetEducationLevelsHook, useGetSkillsHook } from '../../../../utils/utilityHooks';
import GlobalModal from '../../Popups/GlobalModal';
import BubbleButton from '../../Buttons/BubbleButton/BubbleButton';

function EmployerPortalCandidates() {
    const [page] = useState(1);
    const [jobs, setJobs] = useState([]);
    const [cities, setCities] = useState([]);
    const [activeButton, setActiveButton] = useState('');
    const [selectAll, setSelectAll] = useState(false);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [isHovered, setIsHovered] = useState(-1);
    const [candidates, setCandidates] = useState([]);
    const [filteredCandidates, setfilteredCandidates] = useState([]);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const user = useSelector(state => state.user.user);
    const userToken = useSelector(state => state.user.token);
    const features = useSelector(state => state.user.features);
    const educationLevels = useGetEducationLevelsHook();
    let skills = useGetSkillsHook();

    const hasDBAccess = features && features.jobseekersDBAccess === 1;

    const formik = useFormik({
        initialValues: {
            title: '',
            city: '',
            country: '',
            list: '',
            nationality: "",
            education_level: "",
            skills: [],
            yearOfExp: ``,
            language: "",
            salary_range: "",
            gender: "",
        },
        validationSchema: Yup.object({}),
        onSubmit: async (values) => { },
    });

    useEffect(() => {
        const cities = City.getCitiesOfCountry(formik.values.country);
        const citiesFormat = cities.map(city => ({
            value: city.name,
            label: city.name
        }));
        setCities(citiesFormat);
    }, [formik.values.country]);

    useEffect(() => {
        getJobsList(page, 1000, null, { employer_id: user.id }, user.jobseeker_status || user.employer_status)
            .then((response) => {
                const jobsFormat = response.jobs.map(job => ({
                    value: job.title,
                    label: job.title
                }));
                setJobs(jobsFormat);
            })
            .catch((error) => {
                console.error('Failed to fetch jobs after retries:', error);
            });
    }, [user]);

    const tableHeader = [
        t("tableHeader.empty"),
        t("tableHeader.name"),
        t("tableHeader.location"),
        t("tableHeader.group"),
        t("tableHeader.job"),
        t("tableHeader.gender"),
        t("tableHeader.last_active"),
        t("tableHeader.actions")
    ];

    const [jobSeekers, setJobSeekers] = useState([])
    const [favJobSeeker, setFavJobSeeker] = useState([])
    const handleSelectAll = () => {
        if (!selectAll) {
            const allCandidateNames = jobSeekers.map(candidate => candidate.id);
            setSelectedCandidates(allCandidateNames);
        } else {
            setSelectedCandidates([]);
        }
        setSelectAll(!selectAll);
    };
    const handleCandidateSelection = (name) => {
        if (selectedCandidates.includes(name)) {
            setSelectedCandidates(selectedCandidates.filter(candidate => candidate !== name));
        } else {
            setSelectedCandidates([...selectedCandidates, name]);
        }
    };

    const handleRemoveCandidate = async (candidateId) => {
        try {
            await deleteCandidates(user.id, candidateId);
            const candidatesClone = JSON.parse(JSON.stringify(jobSeekers));
            const jobDetail = jobSeekers
            const selectedJobIndex = jobDetail.findIndex(candidate => candidate.id == candidateId);
            if (selectedJobIndex !== -1) {
                candidatesClone.splice(selectedJobIndex, 1);
                setJobSeekers(candidatesClone);
            }
        } catch (error) {
            console.error('Error removing candidate:', error.message);
        }
    };

    useEffect(() => {
        const getCandidateList = async () => {
            try {
                const employer_id = user?.id;
                const token = userToken;
                const page = 1;
                const per_page = 10;
                const filters = {
                    show_good_fit: false,
                    show_possible_fit: false,
                    show_rejected: false
                };

                const applications = await getEmployerApplicationsList(employer_id, token, page, per_page, filters);
                setCandidates(applications);
            } catch (error) {
                console.error('Error fetching applications:', error);
            }
        };

        getCandidateList();
    }, [user, userToken, page]);
    const [listOptions, setListOptions] = useState([]);
    
    // Fetch favorite lists once
    const fetchFavoriteLists = async () => {
        try {
            const response = await getJobSeekerList(user.id)
            const fetchedLists = response.data.favoriteLists.map((item) => ({
                id: item.id,
                label: item.list_name,
                value: item.list_name,
            }));
            setListOptions(fetchedLists)
        } catch (error) {
            console.error("Error fetching favorite lists:", error);
        }
    };
    
    useEffect(() => {
        if (user && user.id) {
            fetchFavoriteLists();
        }
    }, [user.id]);
    
    useEffect(() => {
        setfilteredCandidates(candidates)
    }, [candidates])
    const handleFindCandidates = async () => {
        const hasData = Object.values(formik.values).some(value => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== '' && value !== null && value !== undefined;
        });

        if (hasData) {
            let filteredCandidates = [...allJobSeekers];
            if (formik.values.list) {
                await getFavoriteTalents(user.id, 1, 1000, { jobSeekerList: formik.values.list })
                    .then((response) => {
                        // Deduplicate talents to avoid duplicates in the filtered results
                        const uniqueTalents = [];
                        const talentIds = new Set();
                        
                        response.talents.forEach(talent => {
                            if (!talentIds.has(talent.id)) {
                                talentIds.add(talent.id);
                                uniqueTalents.push(talent);
                            } else {
                                // We've already added this talent, find the existing entry and update list info
                                const existingTalent = uniqueTalents.find(t => t.id === talent.id);
                                
                                // If the talent has list_id or list_name, store it
                                if (talent.list_id || talent.list_name) {
                                    // Initialize the lists array if it doesn't exist
                                    if (!existingTalent.lists) {
                                        existingTalent.lists = [];
                                    }
                                    
                                    // Add the list info to the lists array
                                    existingTalent.lists.push({
                                        list_id: talent.list_id,
                                        list_name: talent.list_name
                                    });
                                }
                            }
                        });
                        
                        filteredCandidates = uniqueTalents;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            if (formik.values.country) {
                filteredCandidates = filteredCandidates.filter(
                    (e) => e?.country?.toLowerCase() === formik.values.country.toLowerCase()
                );
            }
            if (formik.values.city) {
                filteredCandidates = filteredCandidates.filter(
                    (e) => e?.city?.toLowerCase() === formik.values.city.toLowerCase()
                );
            }
            if (formik.values.title) { 
                filteredCandidates = filteredCandidates.filter(
                    (e) => e?.working_title?.toLowerCase().includes(formik.values.title.toLowerCase())
                );
            }
            if (formik.values.nationality) {
                filteredCandidates = filteredCandidates.filter(
                    (e) => e?.nationality?.toLowerCase() === formik.values.nationality.toLowerCase()
                );
            }
            if (formik.values.education_level) {
                filteredCandidates = filteredCandidates.filter((e) =>
                    e?.education?.some((item) => item.education_level.toLowerCase() === formik.values.education_level.toLowerCase())
                );
            }
            const filterSkillFormat = skills.filter((e) => e.value == formik.values.skills)[0]
            if (formik.values.skills && formik.values.skills.length > 0) {
                filteredCandidates = filteredCandidates.filter((e) =>
                    e?.skills.some((item) => item.skill_code == filterSkillFormat.id)
                );
            }
            if (formik.values.yearOfExp) {
                const [start, end] = formik.values.yearOfExp.split('-').map(Number);
                filteredCandidates = filteredCandidates.filter((e) => {
                    const yearsOfExperience = e?.years_of_experience;
                    return yearsOfExperience >= start && yearsOfExperience <= end;
                });
            }
            if (formik.values.language) {
                filteredCandidates = filteredCandidates.filter(
                    (e) => e?.language?.toLowerCase() === formik.values.language.toLowerCase()
                );
            }
            if (formik.values.salary_range) {
                const [minSalary, maxSalary] = formik.values.salary_range.split('-').map(Number);
                filteredCandidates = filteredCandidates.filter((e) => {
                    const basePay = e?.jobPreferences[0]?.basePay;
                    return basePay >= minSalary && basePay <= maxSalary;
                });
            }

            if (formik.values.gender) {
                filteredCandidates = filteredCandidates.filter(
                    (e) => e?.gender?.toLowerCase() === formik.values.gender.toLowerCase()
                );
            }
            setJobSeekers(filteredCandidates);
        } else {
            setJobSeekers(favJobSeeker);
        }
    };

    // Function to refresh jobSeekers data
    const refreshJobSeekers = async () => {
        try {
            setIsLoading(true);
            
            // First, make sure we have the latest list options
            await fetchFavoriteLists();
            
            const response = await getFavoriteTalents(user.id, 1, 1000, {});
            
            // Deduplicate talents based on id to avoid duplicate rows
            const uniqueTalents = [];
            const talentIds = new Set();
            
            // Process the talents to merge list information for the same talent
            response.talents.forEach(talent => {
                if (!talentIds.has(talent.id)) {
                    // This is the first time we've seen this talent
                    talentIds.add(talent.id);
                    // Create a copy with an empty lists array
                    const talentCopy = { ...talent, lists: [] };
                    
                    // If the talent has list_id or list_name, add it to lists array
                    if (talent.list_id || talent.list_name) {
                        talentCopy.lists.push({
                            list_id: talent.list_id,
                            list_name: talent.list_name
                        });
                    }
                    
                    uniqueTalents.push(talentCopy);
                } else {
                    // We've already added this talent, find the existing entry and update list info
                    const existingTalent = uniqueTalents.find(t => t.id === talent.id);
                    
                    // If the talent has list_id or list_name, store it
                    if (talent.list_id || talent.list_name) {
                        // Add the list info to the lists array if it doesn't already exist
                        const listExists = existingTalent.lists.some(
                            list => list.list_id === talent.list_id && list.list_name === talent.list_name
                        );
                        
                        if (!listExists) {
                            existingTalent.lists.push({
                                list_id: talent.list_id,
                                list_name: talent.list_name
                            });
                        }
                    }
                }
            });
            
            // Now match list_ids with list names from listOptions
            uniqueTalents.forEach(talent => {
                if (talent.lists) {
                    talent.lists.forEach(list => {
                        // If we have list_id but no list_name, try to find the name from listOptions
                        if (list.list_id && !list.list_name) {
                            const listOption = listOptions.find(opt => opt.id === list.list_id);
                            if (listOption) {
                                list.list_name = listOption.label;
                            }
                        }
                    });
                }
            });
            
            console.log("Refreshed talents with lists:", uniqueTalents);
            setJobSeekers(uniqueTalents);
            setFavJobSeeker(uniqueTalents);
            setIsLoading(false);
        } catch (error) {
            console.error("Error refreshing job seekers:", error);
            setIsLoading(false);
        }
    };

    // Make a single API call to load favorite talents
    const loadFavoriteTalents = async () => {
        setIsLoading(true);
        try {
            // First, make sure we have the latest list options
            await fetchFavoriteLists();
            
            // Then get the favorite talents
            const response = await getFavoriteTalents(user.id, 1, 1000, {});
            
            // Deduplicate talents based on id to avoid duplicate rows
            const uniqueTalents = [];
            const talentIds = new Set();
            
            // First pass: Create basic talent objects and collect all talents by ID
            response.talents.forEach(talent => {
                if (!talentIds.has(talent.id)) {
                    // This is the first time we've seen this talent
                    talentIds.add(talent.id);
                    // Create a copy with an empty lists array
                    const talentCopy = { ...talent, lists: [] };
                    
                    // If the talent has list_id or list_name, add it to lists array
                    if (talent.list_id || talent.list_name) {
                        talentCopy.lists.push({
                            list_id: talent.list_id,
                            list_name: talent.list_name
                        });
                    }
                    
                    uniqueTalents.push(talentCopy);
                } else {
                    // We've already added this talent, find the existing entry and update list info
                    const existingTalent = uniqueTalents.find(t => t.id === talent.id);
                    
                    // If the talent has list_id or list_name, store it
                    if (talent.list_id || talent.list_name) {
                        // Add the list info to the lists array if it doesn't already exist
                        const listExists = existingTalent.lists.some(
                            list => list.list_id === talent.list_id && list.list_name === talent.list_name
                        );
                        
                        if (!listExists) {
                            existingTalent.lists.push({
                                list_id: talent.list_id,
                                list_name: talent.list_name
                            });
                        }
                    }
                }
            });
            
            // Now match list_ids with list names from listOptions
            uniqueTalents.forEach(talent => {
                if (talent.lists) {
                    talent.lists.forEach(list => {
                        // If we have list_id but no list_name, try to find the name from listOptions
                        if (list.list_id && !list.list_name) {
                            const listOption = listOptions.find(opt => opt.id === list.list_id);
                            if (listOption) {
                                list.list_name = listOption.label;
                            }
                        }
                    });
                }
            });
            
             setJobSeekers(uniqueTalents);
            setFavJobSeeker(uniqueTalents);
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (user && user.id) {
            loadFavoriteTalents();
        }
    }, [user.id]);
    
    const [allJobSeekers, setallJobSeekers] = useState([])
    useEffect(() => {
        const MAX_RETRIES = 1000; // Maximum retries
        let retryCount = 0;
        const fetchJobs = (page, per_page, max_pages, filters,) => {
            getTalentsList(page, per_page, max_pages, filters)
                .then((response) => {
                    setallJobSeekers(response.talents)

                })
                .catch((error) => {
                    if (error.error === 'out of shared memory' && retryCount < MAX_RETRIES) {
                        retryCount++;
                        fetchJobs(1, 1000, 1, {},);
                    } else {
                        console.error('Failed to fetch jobs after retries:', error);
                    }
                });
        }
        fetchJobs(1, 1000, 1, {},)
    }, []);
    useEffect(() => {
        const hasData = Object.values(formik.values).some(value => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== '' && value !== null && value !== undefined;
        });
        if (hasData) { }
        else { setJobSeekers(favJobSeeker) }
    }, [formik.values])

    // Add state variables for sorting
    const [sortBy, setSortBy] = useState(t("defaultSort"));
    const [showSortDropdown, setShowSortDropdown] = useState(false);

    return (
        <div className={styles.container}>
            <GlobalModal
                show={showAccessModal}
                onClose={() => setShowAccessModal(false)}
                title={t('general.upgrade.access_required') || 'Database Access Required'}
                message={t('upgrade.jobseekers_db_access_message') || 'You need to upgrade your subscription to access the job seekers database.'}
                primaryButtonText={t('upgrade.upgrade_now') || 'Upgrade Now'}
                secondaryButtonText={t('general.UI.close') || 'Close'}
                navigateTo="/subscriptions"
                secondaryButtonAction={() => setShowAccessModal(false)}
            />
            
            {hasDBAccess ? (
                <>
                    {filterUI(
                        formik, 
                        activeButton, 
                        setActiveButton, 
                        () => { return ("(3)") }, 
                        jobs, 
                        cities, 
                        listOptions, 
                        handleFindCandidates, 
                        false, 
                        true, 
                        { educationLevels, options: skills },
                        sortBy,
                        setSortBy,
                        showSortDropdown,
                        setShowSortDropdown
                    )}
                    <div className={`${employersJobStyles.row} ${employersJobStyles.tableHeader}`}>
                        {tableHeader.map((item, index) =>
                            <TableHeaderUI
                                key={index.toString()}
                                item={item}
                                index={index}
                                tableHeader={tableHeader}
                                selectAll={selectAll}
                                handleSelectAll={handleSelectAll}
                            />
                        )}
                    </div>
                    
                    {isLoading ? (
                        <div className={employersJobStyles.loaderContainer}>
                            <div className={employersJobStyles.loader}></div>
                            <p>{t('forms.login.processing')}</p>
                        </div>
                    ) : (
                        jobSeekers?.length > 0 && jobSeekers?.map((item, index) => {
                            return (
                                <div
                                    key={index.toString()}
                                    onMouseEnter={() => setIsHovered(index)}
                                    onMouseLeave={() => setIsHovered(-1)}
                                    className={`${employersJobStyles.row} ${employersJobStyles.tableHeader}`}
                                    style={{
                                        height: '100px',
                                        backgroundColor: "white",
                                        border: isHovered === index ? "2px solid #0364b2" : '1px solid #BABBBA',
                                        cursor: "pointer",
                                        position: 'relative'
                                    }}>
                                    {tableHeader.map((headerItem, headerIndex) =>
                                        <TableHeaderUI
                                            key={headerIndex.toString()}
                                            item={item}
                                            index={headerIndex}
                                            tableHeader={tableHeader}
                                            selectAll={selectAll}
                                            handleSelectAll={handleSelectAll}
                                            isContent={true}
                                            isHovered={isHovered}
                                            setIsHovered={setIsHovered}
                                            listContent={true}
                                            isSelected={selectedCandidates?.includes(item?.id)}
                                            handleCandidateSelection={() => handleCandidateSelection(item?.id)}
                                            handleRemoveCandidate={() => handleRemoveCandidate(item?.id)}
                                            listOptions={listOptions}
                                            refreshJobSeekers={refreshJobSeekers}
                                            favTalents={favJobSeeker}
                                        />
                                    )}
                                </div>
                            )
                        })
                    )}
                </>
            ) : (
                <div className={styles.viewCandidatesContainer}>
                    <h2>{t('talents.title') || 'Discover Employees'}</h2>
                    <p>{t('upgrade.jobseekers_db_access_message')}</p>
                    <BubbleButton 
                        dark 
                        headerDarkButton 
                        onClick={() => setShowAccessModal(true)}
                        style={{ padding: '10px 20px', marginTop: '20px' }}
                    >
                        {t('talents.view_candidates') || 'View Candidates'}
                    </BubbleButton>
                </div>
            )}
        </div>
    );
}

export default EmployerPortalCandidates;